import createLucideIcon from '../createLucideIcon';

const ArrowBigDownDash = createLucideIcon('ArrowBigDownDash', [
  ['path', { d: 'M15 5H9', key: '1tp3ed' }],
  ['path', { d: 'M15 9v3h4l-7 7-7-7h4V9h6z', key: 'oscb9h' }],
]);

export default ArrowBigDownDash;
